import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const AlertsContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${themeGet('spacing.lg')};
  padding: ${themeGet('spacing.xl')};
  padding-bottom: 0;

  &:empty {
    display: none;
  }
`;
